import { render } from "./EducationData.vue?vue&type=template&id=4b87d3e3&scoped=true"
import script from "./EducationData.vue?vue&type=script&lang=js"
export * from "./EducationData.vue?vue&type=script&lang=js"

import "./EducationData.vue?vue&type=style&index=0&id=4b87d3e3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87d3e3"]])

export default __exports__